var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Modal',{attrs:{"title":"Select a color scale"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{attrs:{"id":this.pickerElemID}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }